import { CompactSequenceUnenrollModal } from 'sequences-crm-events-lib';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryParams, removeQueryParamsWithoutReload } from './navigationUtils';
import { fetchSequenceEnrollment } from 'crm-timeline-tasks/queues/data/SequencesAPI';
import { OPEN_UNENROLL_SEQUENCE_MODAL } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
const UNENROLL_MODAL_QUERY_PARAM = 'unenrollSequenceModalOpen';
export const useUnenrollSequenceModalActionHandler = ({
  query,
  objectType,
  subjectId
}) => {
  const history = useHistory();
  const [enrollment, setEnrollment] = useState();
  const queryEnrollmentId = useMemo(() => {
    const rawQueryEnrollmentId = query[UNENROLL_MODAL_QUERY_PARAM];
    return rawQueryEnrollmentId ? +rawQueryEnrollmentId : null;
  }, [query]);
  const shouldDoFirstEnrollmentFetch = queryEnrollmentId && !enrollment;
  const hasQueryIdChanged = enrollment && queryEnrollmentId && +enrollment.get('id') === queryEnrollmentId;
  useEffect(() => {
    if (shouldDoFirstEnrollmentFetch || hasQueryIdChanged) {
      fetchSequenceEnrollment(queryEnrollmentId).then(fetchedEnrollment => setEnrollment(fetchedEnrollment)).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }, [shouldDoFirstEnrollmentFetch, hasQueryIdChanged, queryEnrollmentId]);
  const handleUnenrollSequenceModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_UNENROLL_SEQUENCE_MODAL) {
      const {
        enrollmentId
      } = data;
      fetchSequenceEnrollment(enrollmentId).then(fetchedEnrollment => {
        setEnrollment(fetchedEnrollment);
        addQueryParams(history, {
          [UNENROLL_MODAL_QUERY_PARAM]: fetchedEnrollment.get('id')
        }, false);
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      return;
    }
    return;
  }, [setEnrollment, history]);
  const handleCloseUnenrollModal = useCallback(() => {
    // Important to first remove query since these updates are not batched
    // as they are part of a promise chain in CompactSequenceUnenrollModal
    // See https://github.com/reactwg/react-18/discussions/21
    removeQueryParamsWithoutReload(history, [UNENROLL_MODAL_QUERY_PARAM]);
    setEnrollment(null);
  }, [setEnrollment, history]);
  const unenrollSequenceModal = useMemo(() => {
    if (!enrollment) {
      return null;
    }
    return /*#__PURE__*/_jsx(CompactSequenceUnenrollModal, {
      enrollment: enrollment,
      objectType: objectType,
      subjectId: subjectId,
      handleClose: handleCloseUnenrollModal
    });
  }, [handleCloseUnenrollModal, subjectId, objectType, enrollment]);
  return {
    handleUnenrollSequenceModalAction,
    unenrollSequenceModal
  };
};